import axios from "axios";
import { getApiConfig } from "../../apiConfig";

export async function PostCompany(company, modifiedBy, environment) {
  try {
    const apiConfig = await getApiConfig();
    const req = `${apiConfig.BASE_URL}company`;

    const companyPost = {
      company: {
        name: company.name,
        nifCif: company.nifCif,
        responsible: company.responsibleId,
        functionsResponsible: company.functionsResponsibleId,
        // responsibleManagement : company.responsibleManagementId,
        environment: environment,
        modifiedBy: modifiedBy,
        //privacyPolicy: company.text ? company.text : null,
      },
      file: {
        name: company.image ? company.image.fileName : null,
        mimeType: company.image ? company.image.mimeType : null,
        fileData: company.image ? company.image.base64Content : null,
        modifiedBy: modifiedBy,
      },
      textCompany: {
        text: company.text ? company.text : null, //PENDIENTE VARIABLES FRONT
        modifiedBy: modifiedBy
      }
    };
    const response = await axios.post(req, companyPost, apiConfig.HEADERS_CONFIG, {
    });

    return response.data;
  } catch (error) {
    // Manejar el error
    throw error;
  }
}
